export default (mappers, defaultScaffolding = {}) =>
  (scaffolding = defaultScaffolding) =>
  (source, ...extra) =>
    mappers.reduce((acc, mapper) => mapper(acc, source, ...extra), scaffolding);
